import react, {useEffect,useState} from 'react';

import doc from '../../assets/img/V7/doc.svg';
import docx from '../../assets/img/V7/docx.svg';
import pdf from '../../assets/img/V7/pdf.svg';
import ppt from '../../assets/img/V7/ppt.svg';
import xsl from '../../assets/img/V7/xsl.svg';
import zip from '../../assets/img/V7/zip.svg';
import text from '../../assets/img/V7/text.svg';
import dwg from '../../assets/img/V7/dwg.svg';
const KnowledgeFileIconV7 = ({fileType,isPic,className="fileIconclassName"}) => {

    const fileIcon = {
        docm: (<img src={doc} alt=""/>),
        doc: (<img src={doc} alt=""/>),
        docx: (<img src={docx} alt=""/>),
        ppt: (<img src={ppt} alt=""/>),
        pptx: (<img src={ppt} alt=""/>),
        pptm: (<img src={ppt} alt=""/>),
        pdf: (<img src={pdf} alt=""/>),
        xls: (<img src={xsl} alt=""/>),
        xlsx: (<img src={xsl} alt=""/>),
        xlsm: (<img src={xsl} alt=""/>), 
        zip: (<img src={zip} alt=""/>), 
        online: (<img src={text} alt=""/>), 
        dwg: (<img src={dwg} alt=""/>),
        DWG: (<img src={dwg} alt=""/>),
    };

    return (<div className={className}>{fileIcon[fileType] || (<img src={doc} alt=""/>)}</div>)
}

export default KnowledgeFileIconV7;
